'use strict'

import * as BasUtil from '@basalte/bas-util'

/**
 * Service for handling streaming service login via the LoginTopic.
 * Currently only used for B&O devices(Deezer, Tidal).
 * In the future, this service will be extended to handle login for all
 * devices.
 */

angular
  .module('basalteApp')
  .service('BoLogin', [
    '$rootScope',
    'BAS_API',
    'BAS_STREAMING',
    'BAS_CURRENT_CORE',
    'CurrentBasCore',
    BoLogin
  ])

/**
 *
 * @typedef {Object} TBoLoginState
 * @property {Array} services
 * @property {boolean} linked
 * @property {string} username
 */

/**
 * @param $rootScope
 * @param BAS_API
 * @param BAS_STREAMING
 * @param {BAS_CURRENT_CORE} BAS_CURRENT_CORE
 * @param {CurrentBasCore} CurrentBasCore
 */
function BoLogin (
  $rootScope,
  BAS_API,
  BAS_STREAMING,
  BAS_CURRENT_CORE,
  CurrentBasCore
) {
  let _loginTopicListeners = []

  /**
   * @type {TCurrentBasCoreState}
   */
  const currentBasCoreState = CurrentBasCore.get()

  /**
   * @type {TBoLoginState}
   */
  const state = {
    services: [],
    linked: false,
    username: ''
  }

  this.get = get
  this.findService = findService

  init()

  function init () {

    $rootScope.$on(
      BAS_CURRENT_CORE.EVT_CORE_CORE_V2_CONNECTED,
      function (_event, _core, isConnected) {

        if (isConnected) {

          const loginTopic = _getLoginTopic()

          if (loginTopic) {

            loginTopic.subscribe().then(_onLoginTopicAvailable)
          }

        } else {

          BasUtil.executeArray(_loginTopicListeners)
          _loginTopicListeners = []
          state.services = []
          state.linked = false
          state.username = ''
          $rootScope.$emit(BAS_STREAMING.EVT_STREAMING_SERVICES_UPDATED)
        }
      }
    )
  }

  function _onLoginTopicAvailable () {

    const loginTopic = _getLoginTopic()

    if (!loginTopic || !loginTopic.subscribed) return

    _loginTopicListeners.push(BasUtil.setEventListener(
      loginTopic,
      BAS_API.LoginTopic.EVT_SERVICE_UPDATED,
      _onServiceUpdated
    ))

    _getStreamingServices()
  }

  function _onServiceUpdated (service) {

    state.linked = service.linked
    state.username = service.username
    _getStreamingServices()
  }

  function _getStreamingServices () {

    const loginTopic = _getLoginTopic()

    if (!loginTopic) return

    loginTopic.listStreamingServices()
      .then(function (services) {
        state.services = services
        $rootScope.$emit(BAS_STREAMING.EVT_STREAMING_SERVICES_UPDATED)
        $rootScope.$applyAsync()
      })
  }

  /**
   * @param {string} serviceId
   * @returns {TBasStreamingLoginService|null}
   */
  function findService (serviceId) {

    for (let i = 0; i < state.services.length; i++) {

      if (state.services[i].defaultName === 'Music') {

        const music = state.services[i]

        if (!Array.isArray(music.children)) return null

        for (const child of music.children) {

          if (child.defaultName === 'B&O' && Array.isArray(child.children)) {

            return child.children.find(function (item) {
              return item.id === serviceId
            }) || null
          }
        }
      }
    }

    return null
  }

  /**
   * @returns {TBoLoginState}
   */
  function get () {

    return state
  }

  /**
   * @private
   * @returns {?LoginTopic}
   */
  function _getLoginTopic () {

    return currentBasCoreState.core?.core?.loginTopic
  }
}
